import GenericDrawer from './GenericDrawer';

export default GenericDrawer;
